import {
    MAX_TASK_SUBMIT_IMAGE_BYTES,
    MAX_TASK_SUBMIT_IMAGES,
    MAX_TASK_SUBMIT_LINKS,
} from '../../../utils/attachmentUrl';
import { isSafeTaskSubmitImageFile } from '../../../utils/safeImagePreview';

export const isValidProofLink = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return false;
    try {
        const parsed = new URL(raw);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
        return false;
    }
};

export const isTaskSubmitImageFile = (file) => {
    if (!file) return false;
    if (!isSafeTaskSubmitImageFile(file)) {
        return false;
    }
    return file.size <= MAX_TASK_SUBMIT_IMAGE_BYTES;
};

export const isImageAttachment = (url) => {
    const clean = String(url || '')
        .split('?')[0]
        .toLowerCase();
    // Decrypted safe rasters use blob: URLs — only render via <img>, never navigate.
    if (clean.startsWith('blob:')) return true;
    if (/\.svg($|\?)/i.test(clean)) return false;
    return /\.(png|jpe?g|gif|webp)$/.test(clean);
};

export const normalizeSubmissionAttachments = (attachments) => {
    const flattenValue = (value) => {
        if (value === null || value === undefined) return [];
        if (Array.isArray(value)) return value.flatMap(flattenValue);
        const raw = String(value).trim();
        if (!raw) return [];
        if (raw.startsWith('[') && raw.endsWith(']')) {
            try {
                return flattenValue(JSON.parse(raw));
            } catch (_error) {
                // single link
            }
        }
        return [raw];
    };
    return [...new Set(flattenValue(attachments))];
};

export const splitSubmissionAttachments = (attachments, submission = null) => {
    if (
        submission?._decrypted &&
        (Array.isArray(submission._decryptedLinks) ||
            Array.isArray(submission._decryptedImageUrls))
    ) {
        return {
            links: submission._decryptedLinks || [],
            images: submission._decryptedImageUrls || [],
        };
    }
    const normalized = normalizeSubmissionAttachments(attachments);
    const images = [];
    const links = [];
    normalized.forEach((item) => {
        if (isImageAttachment(item)) {
            images.push(item);
        } else {
            links.push(item);
        }
    });
    return { images, links };
};

export { MAX_TASK_SUBMIT_IMAGES, MAX_TASK_SUBMIT_LINKS };

export function getLatestSubmission(task) {
    const submissions = Array.isArray(task?.submissions) ? [...task.submissions] : [];
    return (
        submissions.sort(
            (a, b) => new Date(b.submittedAt) - new Date(a.submittedAt),
        )[0] || null
    );
}
